import { facilitySlice } from './slice'
import axios from 'axios'
import { API_INTERFACE } from '../../../services/constants'

const providerDomainApi = axios.create({ baseURL: process.env.CAREPOINT_URL || process.env.REACT_APP_CAREPOINT_URL });

const { setFacilities, loadFacilities, reset } = facilitySlice.actions

export const fetchFacilityBySpecialtyCodeAndZip =
  ({ specialty, zipcode, distance, networks }: any) =>
  async (dispatch: any) => {
    dispatch(loadFacilities())

    const networksData: any[] = networks.value.map((network: any) => {
      return network.networkName
        ? network.networkName.toString().trim().toLowerCase()
        : network.trim().toLowerCase()
    })

    let facilitiesData = []
    try {
      const params = {
        specialties: specialty,
        zipCode: zipcode,
        distance,
        networks: networksData.join(','),
      };
      const { data: response } = await providerDomainApi.get(API_INTERFACE.FETCH_OPENSEARCH_FACILITIES_BY_ZIPCODE, { params })
      if (response && response.data && response.data.length > 0) {
        facilitiesData = response.data
      }
    } catch (e) {
      facilitiesData = []
    } finally {
      dispatch(setFacilities(facilitiesData))
    }
  }

export const fetchFacilitiesByTin =
  (tin: string | number) => async (dispatch: any) => {
    dispatch(loadFacilities())
    const params = {
      tin
    }
    const response = await providerDomainApi.get(API_INTERFACE.FETCH_OPENSEARCH_FACILITIES, { params })
    const facilities = response?.data?.data
    dispatch(setFacilities(facilities))
    return facilities
  }

export const resetFacilities = () => async (dispatch: any) => {
  dispatch(reset())
}
